import {FormTextField} from '../../../ui/forms/input-field/text-field/text-field';
import {Trans} from '../../../i18n/trans';

interface Props {
  className?: string;
  autoFocus?: boolean;
}

/**
 * The one-time code input, shared by the signup, login and password-reset phone
 * flows so the OTP entry looks and behaves the same everywhere.
 */
export function OtpCodeField({className, autoFocus}: Props) {
  return (
    <FormTextField
      className={className}
      name="code"
      type="text"
      inputMode="numeric"
      autoComplete="one-time-code"
      autoFocus={autoFocus}
      maxLength={8}
      label={<Trans message="Verification code" />}
      required
    />
  );
}
